/**
 * @generated SignedSource<<6a53797edd9f54b0413f7c5a49ac6c3d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingDesigners_designersModule$data = {
  readonly designersHeadModule: {
    readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingModuleHeader_header">;
  } | null;
  readonly primaryDesignersModule: {
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesignerItem_designer">;
    } | null> | null;
  } | null;
  readonly secondaryDesignersModule: {
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesignerItem_designer">;
    } | null> | null;
  } | null;
  readonly tertiaryDesignersModule: {
    readonly isVisible: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesignerItem_designer">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "InteriorsLandingDesigners_designersModule";
};
export type InteriorsLandingDesigners_designersModule$key = {
  readonly " $data"?: InteriorsLandingDesigners_designersModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesigners_designersModule">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "InteriorsLandingModuleItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "InteriorsLandingDesignerItem_designer"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingDesigners_designersModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingHeadModule",
      "kind": "LinkedField",
      "name": "designersHeadModule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteriorsLandingModuleHeader_header"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "primaryDesignersModule",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "secondaryDesignersModule",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InteriorsLandingModule",
      "kind": "LinkedField",
      "name": "tertiaryDesignersModule",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingPage",
  "abstractKey": null
};
})();

(node as any).hash = "273455d01044afc817f432a305eda915";

export default node;
